export enum FlowType {
    Submit = 1,
    Feedback = 2,
    support = 3,
}

class FlowModel {
    id: number;
    title: string;
    outline: string;
    formTypeId: number;
    isActive: boolean;
    formType: string;
    radFlowId: number;
    radFirstWorkTypeId: number;
    flowType: FlowType;
    flowTypeTitle: string;

    constructor(
        id: number,
        title: string,
        outline: string,
        formTypeId: number,
        isActive: boolean,
        formType: string,
        radFlowId: number,
        radFirstWorkTypeId: number,
        flowType: FlowType,
        flowTypeTitle: string,
    ) {
        this.id = id;
        this.title = title;
        this.outline = outline;
        this.formTypeId = formTypeId;
        this.isActive = isActive;
        this.formType = formType;
        this.radFlowId = radFlowId;
        this.radFirstWorkTypeId = radFirstWorkTypeId;
        this.flowType = flowType;
        this.flowTypeTitle = flowTypeTitle;
    }

    public static fromJson(json: any): FlowModel {
        return new FlowModel(
            json["id"],
            json["title"],
            json["outline"],
            json["formTypeId"],
            json["isActive"],
            json["formType"],
            json["radFlowId"],
            json["radFirstWorkTypeId"],
            json["flowType"],
            json["flowTypeTitle"],
        );
    }
}


export interface FlowGetPayloadFilterModel {
    id?: number;
    title?: string;
    formTypeId?: number;
    isActive?: number;
    flowType?: FlowType;
}

export interface FlowGetPayloadModel {
    pageSize?: number;
    pageNumber?: number;
    Filters?: FlowGetPayloadFilterModel;
}


export class FlowPayloadModel {
    id: number;
    title: string;
    outline: string;
    formTypeId: number;
    isActive: boolean;
    formType: string;
    radFlowId: number;
    radFirstWorkTypeId: number;
    flowType: FlowType;
     constructor(
        id: number = 0,
        title: string="",
        outline: string="",
        formTypeId: number = 0,
        radFlowId: number = 0,
        radFirstWorkTypeId: number = 0,
        isActive: boolean = false,
        formType: string="",
        flowType: FlowType = FlowType.Submit,
        
    ) {
        this.id = id;
        this.title = title;
        this.outline = outline;
        this.formTypeId = formTypeId;
        this.isActive = isActive;
        this.radFirstWorkTypeId = radFirstWorkTypeId;
        this.radFlowId = radFlowId;
        this.formType = formType;
        this.flowType = flowType;
    }
    public static fromFlowModel(model: FlowModel): FlowPayloadModel {
        return new FlowPayloadModel(model.id, model.title,model.outline, model.formTypeId , model.radFlowId, model.radFirstWorkTypeId
           ,  model.isActive,
            model.formType , 
            model.flowType  
        )
    }
}
export default FlowModel;
